import { actions } from './actions'

const initialState = {
  horariosEntrega: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
}

export default function horariosEntregaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_REQUESTED:
      return { ...state, horariosEntregaMadrid: { ...state.horariosEntrega, loading: true } }
    case actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_SUCCEEDED:
      return {
        ...state,
        horariosEntrega: {
          ...state.horariosEntrega,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_FAILED:
      return {
        ...state,
        horariosEntrega: {
          ...state.horariosEntrega,
          loading: false,
          error: action.error,
        },
      }

    case actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_REQUESTED:
      return { ...state, horariosEntregaMadrid: { ...state.horariosEntrega, loading: true } }
    case actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        horariosEntrega: {
          ...state.horariosEntrega,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_FAILED:
      return {
        ...state,
        horariosEntrega: {
          ...state.horariosEntrega,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
